import * as React from 'react';

import * as styles from './DailyrentLayout.css';

interface IDailyrentLayoutProps {
  topContent: React.ReactNode;
  columnContent: React.ReactNode;
  header: React.ReactNode;
  sidebar: React.ReactNode;
}

export const DailyrentLayout = ({ topContent, columnContent, header, sidebar }: IDailyrentLayoutProps) => {
  return (
    <section className={styles['root']}>
      {header}
      {topContent}
      <div className={styles['container']}>
        <div className={styles['content']}>{columnContent}</div>
        <div className={styles['sidebar']}>{sidebar}</div>
      </div>
    </section>
  );
};
